import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatTooltipModule} from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { DialogService } from '../../../services/dialog.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sign-up-customer-type-selection',
  imports: [MatRadioModule, MatFormFieldModule, FormsModule, MatInputModule, ReactiveFormsModule, MatTooltipModule, TranslateModule],
  templateUrl: './sign-up-customer-type-selection.component.html',
  styleUrl: './sign-up-customer-type-selection.component.scss'
})
export class SignUpCustomerTypeSelectionComponent {

  existingCustomer = true
  accountId = new FormControl(
    { value: '', disabled: !this.existingCustomer },
    [
      Validators.required,
      Validators.pattern(/^4[0-9X]*$/), // Must start with 4 and only digits or 'X' allowed
      Validators.maxLength(16),
      Validators.minLength(10)
    ]
  );
  unmaskedAccountId = '';
  maskedAccountId = '';
  companyName = new FormControl({value: '', disabled: this.existingCustomer}, [Validators.required, Validators.maxLength(50)]);
  router = inject(Router);
  dialogService = inject(DialogService);
  continue() {
    console.log(this.existingCustomer);
    this.dialogService.closeAllDialog();
    if(this.existingCustomer) {
      this.router.navigate(['/create-account-existing'], {queryParams: {accountId: this.unmaskedAccountId}})
    } else {
      this.router.navigate(['/create-account'], {queryParams: {companyName: this.companyName.value}});

    }
  }

  submit() {
    console.log('==> submit', this.accountId);
  }
  onClose(){
    this.dialogService.closeAllDialog();
    this.dialogService.openSignInDialog();
  }

  changeExistingCustomer(value: boolean) {
    if(value) {
      this.accountId.enable();
      this.companyName.disable();
      this.existingCustomer = true;
    } else {
      this.accountId.disable();
      this.companyName.enable();
      this.existingCustomer = false;
    }

  }

    backToLogin() {
    this.dialogService.openSignInDialog();
  }

  openImageDialog() {
    this.dialogService.openCustomerTypeImageDialog();
  }

  openTextDialog() {
    this.dialogService.openCustomerTypeTextDialog();
  }

maskAccountId(): void {
  if (this.accountId && this.accountId.value) {
    const value = this.accountId.value;
    this.maskedAccountId = value.length > 3 ? value.slice(0, 3) + 'X'.repeat(value.length - 3) : value;
    this.unmaskedAccountId = this.accountId.value;
    console.log('==> maskedAccountId', this.maskedAccountId);
    console.log('==> unmaskedAccountId', this.unmaskedAccountId);
    this.accountId.setValue(this.maskedAccountId);
    // this.accountId.setValue(maskedAccountId);
  }
}

onFocus() {
  this.accountId.setValue(this.unmaskedAccountId);
}

}
